import { BackgroundMedia } from '../page-components/background-media.model';
import { Padding } from '../page-components/padding.model';

export class PageLayout {
  FullWidth: boolean = false;
  SiteWidthType: number = 0;
  Padding: Padding = new Padding();
  PageWidth: string = '';
  Background?: BackgroundMedia;
}
